import React from 'react';

const SkipToContentMenuContext = React.createContext();

export default SkipToContentMenuContext;